import { filterInteraction } from '../utils/performance-analytics/index.tsx';

export const setInteractionFeedbackMark = () => {
	filterInteraction.mark('feedback');
};

export const setInteractionStartMark = () => {
	filterInteraction.start();
};
